import { Typography } from '@material-tailwind/react';

const TdTable = ({ children, classe }) => {
  return (
    <td className={classe}>
      <div className="flex flex-col">
        <Typography variant="small" color="black" className="font-normal">
          {children}
        </Typography>
      </div>
    </td>
  );
};

export default TdTable;
